//DropDown utils.js

const INCREMENT_ACTIVE = "INCREMENT_ACTIVE";
const DECREMENT_ACTIVE = "DECREMENT_ACTIVE";
const SELECTED = "SELECTED";
const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
const DESELECT = "DESELECT";

const optionOnClick = (dispatch, index) => () => {
    dispatch({ type: SELECTED, index });
};

//Key codes for onKeyDown
const escKey = 27;
const enterKey = 13;
const keyUpCode = 38;
const keyDownCode = 40;
const keyRightCode = 39;
const keyLeftCode = 37;

const onKeyDown = (dispatch) => (e) => {
    switch (e.keyCode) {
        case enterKey: {
            e.preventDefault();
            dispatch({ type: SELECTED });
            break;
        }
        case escKey: {
            e.preventDefault();
            dispatch({ type: DESELECT });
            break;
        }
        case keyLeftCode:
        case keyUpCode: {
            e.preventDefault();
            dispatch({ type: DECREMENT_ACTIVE });
            break;
        }
        case keyRightCode:
        case keyDownCode: {
            e.preventDefault();
            dispatch({ type: INCREMENT_ACTIVE });
            break;
        }
        default:
    }
};
const textInputOnClick = (dispatch) => () => {
    dispatch({ type: SELECTED });
};

const textInputOnChange = (dispatch) => (e) => {
    dispatch({ type: SET_SEARCH_TEXT, searchText: e.target.value });
};

const isDescendent = (parent, child) => {
    //returns true if the child is in the parent's HTML tree
    if (!child || !child.parentElement) {
        return false;
    }
    if (child.parentElement === parent) {
        return true;
    }

    return isDescendent(parent, child.parentElement);
};

const reducer = (state, action) => {
    switch (action.type) {
        case INCREMENT_ACTIVE: {
            const activeIndex =
                state.activeIndex + 1 >= state.displayCount
                    ? 0
                    : state.activeIndex + 1;
            const active = true;
            return {
                ...state,
                active,
                activeIndex,
            };
        }

        case DECREMENT_ACTIVE: {
            const activeIndex =
                state.activeIndex - 1 < 0
                    ? state.displayCount - 1
                    : state.activeIndex - 1;
            const active = true;
            return {
                ...state,
                active,
                activeIndex,
            };
        }

        case SET_SEARCH_TEXT: {
            const searchText =
                action.searchText.replace(/[^\w\s-]/gi, "", "") || "";
            const regex = RegExp(searchText, "i");
            const display = state.options
                .reduce((display, opt) => {
                    if (regex.test(opt.mainKey)) {
                        display.push(opt.mainKey);
                    }
                    return display;
                }, [])
                .sort();
            return {
                ...state,
                active: true,
                searchText,
                display,
                displayCount: display.length,
                activeIndex: -1,
            };
        }
        case DESELECT: {
            const searchText =
                state.activeIndex === -1 &&
                !state.display.includes(state.searchText)
                    ? ""
                    : state.searchText;
            return {
                ...state,
                active: false,
                searchText,
                activeIndex: -1,
            };
        }
        case SELECTED: {
            const active = !state.active;
            if (active) {
                // opening
                const display = state.options.map((it) => it.mainKey).sort();
                return {
                    ...state,
                    active,
                    searchText: "",
                    activeIndex: -1,
                    display,
                    displayCount: display.length,
                };
            } else {
                const searchText =
                    state.display[action.index] ||
                    state.display[state.activeIndex] ||
                    "";
                return {
                    ...state,
                    active,
                    searchText,
                    activeIndex: -1,
                };
            }
        }
        default: {
            const options =
                (Array.isArray(action.options) && action.options) || [];
            const display = options.map((it) => it.mainKey).sort();
            return {
                options,
                optionsCount: options.length,
                display,
                displayCount: display.length,
                searchText: "",
                active: false,
                activeIndex: -1,
            };
        }
    }
};

const getOptionAccesibilityId = (wrapperId, activeItemId) => {
    if (activeItemId < 0) {
        return "";
    }
    return `${wrapperId}-option-${activeItemId}`;
};

export {
    optionOnClick,
    onKeyDown,
    textInputOnClick,
    textInputOnChange,
    reducer,
    getOptionAccesibilityId,
    isDescendent,
    DESELECT,
};
